import React from "react";
import Chart from "react-apexcharts";

function BancarizacionChart() {
  const data = {
    options: {
      chart: {
        type: "bar",
      },
      plotOptions: {
        bar: {
          horizontal: false, // Barras verticales
          columnWidth: "70%", // Ajusta el ancho de las barras
          dataLabels: {
            position: "top", // Posiciona las etiquetas en la parte superior de cada barra
          },
        },
      },
      xaxis: {
        categories: [
          "Banamex",
          "Banorte",
          "BBVA Bancomer",
          "HSBC",
          "Santander",
          "CHEQUE",
        ],
        title: {
          text: "Bancos",
        },
        labels: {
          formatter: (val) => val + " mil",
        },
      },
      yaxis: {
        title: {
          text: "Trabajadores",
        },
        labels: {
          formatter: (val) => val + " mil",
        },
      },
      colors: ["#800026"], // Un tono vino/burdeo
      dataLabels: {
        enabled: true,
        formatter: (val) => val / 1000 + " mil",
        offsetY: -20, // Desplaza las etiquetas 15px hacia abajo desde el "top" de la barra
        style: {
          colors: ["#313131"], // Cambia el color del texto a #313131
          fontSize: "14px",   // Ajusta el tamaño si es necesario
          fontWeight: "bold", // Opcional, para hacerlo más legible
        },
      },
      title: {
        text: "Trabajadores por Bancos",
        align: "left",
      },
      grid: {
        borderColor: "#e7e7e7",
        row: {
          colors: ["#fff", "#f2f2f2"],
          opacity: 0.5,
        },
      },
      legend: {
        show: false,
      },
    },
    series: [
      {
        name: "Trabajadores",
        data: [10000, 3000, 8000, 1000, 32000, 0],
      },
    ],
  };

  return (
    <div className="graficas2">
      <Chart
        options={data.options}
        series={data.series}
        type="bar"
        height={350}
      />
    </div>
  );
}

export default BancarizacionChart;
